import { format, parse } from "date-fns";
import DatePicker from "react-datepicker";
import { Controller, FieldValues } from "react-hook-form";
import ReactInputMask from "react-input-mask";
import { DateFieldProps } from "../medCheckBoxList/type";
import { FC } from "react";

const DateField = <T extends FieldValues>({
  control,
  name,
  label,
}: DateFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className="row align-items-center mb-3">
          <label className="col-lg-4 col-md-4 col-12 form-label text-end mb-0 pe-0">
            {label}
          </label>

          <div className="col-lg-8 col-md-8 col-12 position-relative">
            <DatePicker
              selected={
                field.value
                  ? parse(field.value, "yyyy-MM-dd", new Date())
                  : null
              }
              onChange={(date) =>
                field.onChange(date ? format(date, "yyyy-MM-dd") : "")
              }
              dateFormat="MM/dd/yyyy"
              className={`form-control ${error?.message ? "is-invalid" : ""}`}
              placeholderText="mm/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              customInput={
                <ReactInputMask mask="99/99/9999">
                  {(inputProps: {}) => <input {...inputProps} />}
                </ReactInputMask>
              }
              wrapperClassName="w-100"
              
            />
          </div>
        </div>
      )}
    />
  );
};
export default DateField;